<template>
    <div>
        <BudGetSummary />
    </div>
</template>

<script>
    import BudGetSummary from './BudgetSummary'
    export default {
        components:{
            BudGetSummary
        }
    }
</script>

<style lang="scss" scoped>

</style>